/* metro-ui-components@9.20.0 */
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var PropTypes = require("prop-types");
var classnames = require("classnames");
if (!process.env.ALEX_UI_IGNORE_CSS) { require('./Summary.css'); }
var Icon_1 = require("./Icon");
var Button_1 = require("./Button");
var moduleClassNameFactory_1 = require("./util/moduleClassNameFactory");
var ErrorMessage_1 = require("./ErrorMessage");
var moduleClassName = moduleClassNameFactory_1.moduleClassNameFactory("m-summary");
exports.Summary = function Summary(_a) {
    var className = _a.className, children = _a.children, legacy = _a.legacy, large = _a.large, disabled = _a.disabled, hasWarning = _a.hasWarning;
    return (React.createElement("div", { className: classnames(moduleClassName(), disabled && moduleClassName("isDisabled"), legacy && moduleClassName("isLegacy"), large && moduleClassName("isLarge"), hasWarning && moduleClassName("hasWarning"), className) }, children));
};
exports.Summary.propTypes = {
    disabled: PropTypes.bool,
    legacy: PropTypes.bool,
    large: PropTypes.bool,
    hasWarning: PropTypes.bool
};
exports.SummaryIcon = function SummaryIcon(_a) {
    var type = _a.type;
    return (React.createElement("div", { className: moduleClassName("icon") },
        React.createElement(Icon_1.Icon, { type: type })));
};
exports.SummaryIcon.propTypes = {
    type: PropTypes.oneOf(Icon_1.IconTypesArray).isRequired
};
exports.SummaryContent = function SummaryContent(_a) {
    var children = _a.children;
    return React.createElement("div", { className: moduleClassName("content") }, children);
};
exports.SummaryErrorMessage = function SummaryErrorMessage(_a) {
    var children = _a.children;
    return (React.createElement(ErrorMessage_1.ErrorMessage, { className: moduleClassName("errorMessage") }, children));
};
exports.SummaryErrorMessage.displayName = "SummaryErrorMessage";
exports.SummaryButtons = function SummaryButtons(_a) {
    var children = _a.children;
    return React.createElement("div", { className: moduleClassName("buttons") }, children);
};
exports.SummaryButton = function SummaryButton(_a) {
    var id = _a.id, onClick = _a.onClick, className = _a.className, title = _a.title, iconType = _a.iconType, disabled = _a.disabled;
    return (React.createElement(Button_1.Button, { id: id, role: "button", kind: "ghost", onClick: onClick, className: classnames(moduleClassName("button"), className), title: title, disabled: disabled },
        React.createElement(Icon_1.Icon, { type: iconType })));
};
exports.SummaryButton.propTypes = {
    id: PropTypes.string,
    onClick: PropTypes.func,
    className: PropTypes.string,
    title: PropTypes.string,
    iconType: PropTypes.oneOf(Icon_1.IconTypesArray).isRequired,
    disabled: PropTypes.bool
};
exports.SummaryDetailListTitle = function SummaryDetailListTitle(_a) {
    var className = _a.className, children = _a.children;
    return (React.createElement("div", { className: classnames(moduleClassName("detailList-title"), className) }, children));
};
exports.SummaryDetailListTitle.propTypes = {
    className: PropTypes.string
};
exports.SummaryDetailList = function SummaryDetailList(_a) {
    var className = _a.className, children = _a.children;
    return (React.createElement("div", { className: classnames(moduleClassName("detailList"), className) }, React.Children.map(children, function (child, index) {
        if (!child) {
            return child;
        }
        return React.cloneElement(child, {
            key: index,
            rowIndex: 1 + index
        });
    })));
};
exports.SummaryDetailList.propTypes = {
    className: PropTypes.string
};
// @ts-ignore
exports.SummaryDetailListItem = function SummaryDetailListItem(_a) {
    var children = _a.children, label = _a.label, rowIndex = _a.rowIndex;
    return [
        React.createElement("div", { key: "label", className: classnames(moduleClassName("detailList-label")), style: {
                // @ts-ignore
                msGridRow: rowIndex,
                msGridColumn: 1
            } }, label),
        React.createElement("div", { key: "content", className: classnames(moduleClassName("detailList-content")), style: {
                // @ts-ignore
                msGridRow: rowIndex,
                msGridColumn: 2
            } }, children)
    ];
};
exports.SummaryDetailListItem.propTypes = {
    label: PropTypes.string.isRequired
};